import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Form,
    notification,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {addUserFxn} from "./actions";
import {sanitizeUserNameInput, vegNonVeg, designationList} from "../../components/_utils/_utils";
import {tableListFxn} from "../pos/actions";
import {useNavigate} from "react-router-dom";


let initState = {
    name: "",
    // email: "",
    loginId: "",
    password: "",
    confirmPassword: "",
    // address: ""
    designation: ""
}

function AddUser(props) {
    let dispatch = useDispatch()
    const navigate = useNavigate();
    let [state, setState] = useState(initState)
    let events = {
        _updateState: (data) => {
            setState((prevState) => {
                return {
                    ...prevState,
                    ...data
                }
            })
        }
    }

    const handleSubmit = async (e) => {
        const {form} = props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {
            if (!err) {
                if (!valData.name) {
                    notification.warning({message: "Enter Name"});
                    return;
                }
                // if (!valData.email) {
                //     notification.warning({message: "Choose email / username"});
                //     return;
                // }
                if (!valData.loginId) {
                    notification.warning({message: "Choose email / username"});
                    return;
                }
                if (!valData.password) {
                    notification.warning({message: "Enter password"});
                    return;
                }
                if (!valData.confirmPassword) {
                    notification.warning({message: "Enter confirm password"});
                    return;
                }
                if (valData.password !== valData.confirmPassword) {
                    notification.warning({message: "Password not match"});
                    return;
                }
                if (!valData.designation) {
                    notification.warning({message: "Choose designation"});
                    return;
                }
                // let x = await dispatch(addUserFxn({...valData, userType:valData.designation}));
                let x = await dispatch(addUserFxn({
                    ...valData,
                    email: valData.loginId,
                    userType: valData.designation
                }));
                // if (x && x.success) {
                //     navigate("/user-list")
                //     props.form.setFieldsValue({
                //         ...initState
                //     });
                //
                // }
                if (x && x.success) {

                    setTimeout(() => {
                        navigate("/user-list");
                    }, 300);
                }
            }
        });
    };

    let [tableList, setTableList] = useState([])
    let loadTables = async () => {
        let {data} = await tableListFxn();
        setTableList(data);
    }
    useEffect(() => {
        loadTables()
    }, [])

    let inputTypes = {
        fields: [
            {
                key: "name",
                label: "Name *",
                span: "col-md-4",
                required: true
            },
            {
                key: "loginId",
                label: "Email / Username *",
                span: "col-md-4",
                type: "text",
                required: true,
                onChange: ({target}) => {
                    props.form.setFieldsValue({
                        loginId: sanitizeUserNameInput(target.value),
                    });
                }
            },
            {
                key: "password",
                label: "Password *",
                span: "col-md-4",
                required: true
            },
            {
                key: "confirmPassword",
                label: "Confirm Password *",
                span: "col-md-4",
                required: true
            },
            {
                key: "designation",
                label: "Designation *",
                span: "col-md-4",
                required: true,
                message: "Please select the designation",
                type: "select",
                options: designationList,
                keyAccessor: (x) => x.value,
                valueAccessor: (x) => x.label,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        designation: x,
                    });
                }
            }
            // {
            //     key: "tables",
            //     label: "Tables",
            //     span: "col-md-4",const designationList = [
            //   { label: "Select Designation", value: "" }, // 👈 placeholder
            //   { label: "MD", value: "MD" },
            //   { label: "GM", value: "GM" },
            //   { label: "F&B Manager", value: "F&B Manager" },
            //   { label: "HOD", value: "HOD" },
            //   { label: "Cashier", value: "Cashier" },
            //   { label: "ARM", value: "ARM" },
            //   { label: "Captain", value: "Captain" },
            //   { label: "Steward", value: "Steward" }
            // ];
            //     type: "select",
            //     options: tableList,
            //     showSearch: true,
            //     multiple: true,
            //     keyAccessor: (x) => x.name,
            //     valueAccessor: (x) => `${x.name}`,
            //     onChange: (x) => {
            //         props.form.setFieldsValue({
            //             tables: x,
            //         });
            //     },
            // },
            // {
            //     key: "address",
            //     label: "Address *",
            //     span: "col-md-12"
            // },

        ],
    };

    return (
        <PageHeader title={"Add User"}>
            <Form onSubmit={handleSubmit}>
                <div className="form-elements-wrapper">
                    <div className="card-body">
                        <div className={"row"}>
                            {inputTypes.fields.map((item, key) => {
                                return !item.hidden ? (
                                    <div className={`${item.span ? item.span : "col-md-6"}`}
                                         key={key}>
                                        <GetEachFormFields {...props.form} item={item}/>
                                    </div>
                                ) : null;
                            })}
                        </div>
                        <div className={'row'}>
                            <div className={'col-md-12'}>
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </Form>
        </PageHeader>
    );
}

export default Form.create()(AddUser);
